export const CalendarBookingMessages = {
    historyAbsence: {
        title: 'A historic absence',
    },
    previousEntitlementYear: {
        title: 'Previous entitlement year',
        message: "If you were to book an absence in a previous entitlement year, it wouldn't affect your current year's entitlement",
    },
};
